import request from '../request'

/**
 * 新增项目跟踪
 * @param {Object} data 表单数据
 */
export function addProjectTrack(data) {
    return request({
        url: '/market-service/market/projectTrack/add',
        method: 'POST',
        data,
    })
}

/**
 * 删除项目跟踪
 * @param {number|string} id 项目ID
 */
export function deleteProjectTrack(id) {
    return request({
        url: `/market-service/market/projectTrack/delete/${id}`,
        method: 'DELETE',
    })
}

/**
 * 获取项目跟踪详情
 * @param {number|string} id 项目ID
 */
export function getProjectTrackDetail(id) {
    return request({
        url: `/market-service/market/projectTrack/detail/${id}`,
        method: 'GET',
    })
}

/**
 * 导出项目跟踪
 * @param {Object} params 查询参数
 */
export function exportProjectTrack(params) {
    return request({
        url: '/market-service/market/projectTrack/export',
        method: 'GET',
        params,
        responseType: 'blob', // 导出文件时建议加上
    })
}

/**
 * 导入项目跟踪
 * @param {FormData} data 文件表单数据
 */
export function importProjectTrack(data) {
    return request({
        url: '/market-service/market/projectTrack/import',
        method: 'POST',
        data,
        headers: {
            'Content-Type': 'multipart/form-data', // 文件上传时建议加上
        },
    })
}

/**
 * 获取项目跟踪列表
 * @param {Object} params 查询参数（分页、筛选等）
 */
export function getProjectTrackList(params) {
    return request({
        url: '/market-service/market/projectTrack/list',
        method: 'GET',
        params,
    })
}

/**
 * 修改项目跟踪
 * @param {Object} data 表单数据
 */
export function updateProjectTrack(data) {
    return request({
        url: '/market-service/market/projectTrack/update',
        method: 'POST',
        data,
    })
}


export function getDeptAreaList(params) {
    return request({
        url: '/market-service/market/projectTrack/deptAreaList',
        method: 'GET',
        params,
    })
}